export default __webpack_public_path__ + "static/media/fsa-store-eligibility-list.a8b918af.svg";